import { Reveal } from "@/components/yanre/Reveal";
import { useLocale } from "@/i18n/LocaleContext";

// SECTION — How It Works. Same commercial process architecture as Open Your Gym.
const STEPS = [
  ["pts.process.1.t", "Consultation", "pts.process.1.b", "We understand you, your space, your concept and your investment level."],
  ["pts.process.2.t", "Project", "pts.process.2.b", "Together we define the equipment selection and the studio layout."],
  ["pts.process.3.t", "30% Order", "pts.process.3.b", "Confirm the project and start production with a 30% payment to the factory."],
  ["pts.process.4.t", "Production", "pts.process.4.b", "YANRE manufactures and prepares your equipment."],
  ["pts.process.5.t", "70% Before Shipping", "pts.process.5.b", "The final balance is settled before shipment, per the official contract."],
  ["pts.process.6.t", "Shipping", "pts.process.6.b", "International logistics coordinated for your project."],
  ["pts.process.7.t", "After-Sales", "pts.process.7.b", "Factory-backed support after installation."],
];

export const PTProcess = () => {
  const { t } = useLocale();
  return (
    <section className="section-dark py-24 lg:py-32" data-testid="pt-process-section">
      <div className="container-edge">
        <Reveal>
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-10 bg-signal" />
            <span className="overline">{t("pts.process.label", "How It Works")}</span>
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="max-w-4xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-white sm:text-6xl">
            {t("pts.process.h2a", "A clear process.")}{" "}
            <span className="text-signal">{t("pts.process.h2b", "From idea to opening day.")}</span>
          </h2>
        </Reveal>

        <ol className="mt-14 space-y-0 border-t border-carbon-700" data-testid="pt-process-list">
          {STEPS.map(([tk, tf, bk, bf], i) => (
            <Reveal key={tk} delay={0.04 * i}>
              <li className="grid gap-2 border-b border-carbon-700 py-7 sm:grid-cols-[100px_240px_1fr] sm:items-baseline sm:gap-8" data-testid={`pt-process-step-${i + 1}`}>
                <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-signal">0{i + 1}</span>
                <span className="font-display text-xl font-bold uppercase tracking-wide text-white sm:text-2xl">{t(tk, tf)}</span>
                <span className="text-sm font-light leading-relaxed text-titanium/65 sm:text-base">{t(bk, bf)}</span>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
